// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vSI8C","label":"styles_label__15Yth"};